


















import { Component, Prop, Vue } from "vue-property-decorator";
//  components
//  types

@Component({})
export default class SortableArrows extends Vue {
  @Prop({ required: true, type: Boolean }) sortDesc!: boolean;
  @Prop({ required: true, type: Boolean }) sortBy!: boolean;

//  @Getters

//  @Methods
}
